import { STUDY_STATUS } from './studyConstants';

/**
 * Decides whether a study's start time is meaningful enough to render. Excludes only the draft and starting statuses.
 *
 * @param status - Current study status.
 * @returns True unless the study is a draft or still starting.
 */
const shouldDisplayStudyStartTime = (status: string | undefined) =>
  ![STUDY_STATUS.DRAFT, STUDY_STATUS.STARTING].includes(status ?? '');

export { shouldDisplayStudyStartTime };
